import Block from "Mixins/Block";

export default Block("component-publication", {
  fn: {},
  onLoad() {
    const items = document.querySelectorAll(`${this.selector}__item button`);
    if (items !== undefined && items.length > 0) {
      for (let i = 0; i < items.length; i++) {
        items[i].addEventListener("click", function () {
          const parent = this.parentElement;
          let content = this.nextElementSibling;
          if (
            parent.classList.contains("component-publication__item--active")
          ) {
            parent.classList.remove("component-publication__item--active");
            this.setAttribute("aria-expanded", "false");
          } else {
            parent.classList.add("component-publication__item--active");
            this.setAttribute("aria-expanded", "true");
            content.focus();
          }
        });
      }
    }
  },
});
